import { InjectionToken } from '@angular/core';
import { InjectedFile } from './file-overlay.component';

export const FILE_OVERLAY_DATA = new InjectionToken<InjectedFile>('FILE_OVERLAY_DATA');
